import {
  Autocomplete,
  Box,
  Checkbox,
  createFilterOptions,
  FormControlLabel,
  Modal,
  Stack,
  TextField,
  Typography,
  IconButton,
  InputLabel,
  CircularProgress
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Close as CloseIcon, Label } from "@mui/icons-material";
import { BIBlue, BIGrey } from "../../assets/helpers";
import SaveIcon from "@mui/icons-material/Save";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { Postrequestcall } from "../../request/Postrequest";
import {
  DELETE_USER_COMPANIES,
  FETCH_COMPANIES,
  FETCH_COMPANIES_2,
  FETCH_USERS_COMPANIES,
  SAVE_COMPANIES,
  SAVE_USER_COMPANIES
} from "../../constant/Apipath";
import { useDispatch, useSelector } from "react-redux";
import UseDebounce from "../common/UseDebounce";
import Removeduplicates from "../common/Removeduplicate";
import moment from "moment";
import { setShowalert } from "../../redux/actions/actions";
import PromptModal from "../common/PromptModal";
import DeleteIcon from "@mui/icons-material/Delete";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { English } from "../../constant/EnglishFallback";

const filter = createFilterOptions();

export default function Addcompany(props) {
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const [compnayInfo, setCompanyinfo] = useState({
    id: 0,
    roleId: 0,
    startDate: null,
    endDate: null,
    present: false,
    jobDescription: "",
    prevJobdescription: ""
  });
  const [compnaylist, setCompanylist] = useState([]);
  const [selectCompany, setSelectcompany] = useState(false);
  const [company, setCompany] = useState({ companyId: 0, title: "" });
  const [openStartdate, setOpenstartdate] = useState(false);
  const [openEnddate, setOpenenddate] = useState(false);
  const [isCompanyOutOfFrameFlag, setIsCompanyOutOfFrameFlag] = useState(false);
  const [timeframeModalType, setTimeframeModalType] = useState(null);
  const [timeframeModalTitle, setTimeframeModalTitle] = useState(null);
  const [timeframeModalBody, setTimeframeModalBody] = useState(null);
  const [updateModalButton, setUpdateModalButton] = useState("");
  const [addDetailModalButton, setAddDetailModalButton] = useState("");
  const [companyStartDateNew, setCompanyStartDateNew] = useState("");
  const [companyEndDateNew, setCompanyEndDateNew] = useState("");
  const [discardModalOpen, setDiscardModalOpen] = useState(false);
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
  const [disableSave, setDisablesave] = useState(true);
  const [isLoading, setIsloading] = useState(false);

  const dispatch = useDispatch();

  const {
    TEXT_DESC_CONFIRMATION = English?.Profile?.TEXT_DESC_CONFIRMATION,
    MODAL_DISCARD_TITLE = English?.Profile?.MODAL_DISCARD_TITLE,
    DISCARD_MODAL_DESCRIPTION = English?.Profile?.DISCARD_MODAL_DESCRIPTION,
    BUTTON_DISCARD = English?.Profile?.BUTTON_DISCARD,
    BUTTON_GOBACK = English?.Profile?.BUTTON_GOBACK,
    MODAL_DELETE_TITLE = English?.Profile?.MODAL_DELETE_TITLE,
    BUTTON_DELETE = English?.Profile?.BUTTON_DELETE,
    BUTTON_CANCEL = English?.Profile?.BUTTON_CANCEL,
    TEXT_EDIT_COMPANY_TO_PROFILE = English?.Profile?.TEXT_EDIT_COMPANY_TO_PROFILE,
    TEXT_ADD_COMPANY_TO_PROFILE = English?.Profile?.TEXT_ADD_COMPANY_TO_PROFILE,
    BUTTON_ADD = English?.Profile?.BUTTON_ADD,
    TEXT_COMPANY = English?.Profile?.TEXT_COMPANY,
    TEXT_START_DATE = English?.Profile?.TEXT_START_DATE,
    TEXT_END_DATE = English?.Profile?.TEXT_END_DATE,
    TEXT_PRESENT = English?.Profile?.TEXT_PRESENT,
    TEXT_JOB_DESCRIPTION = English?.Profile?.TEXT_JOB_DESCRIPTION,
    TEXT_START_DATE_OR_UNCHECKED_PRESENT = English?.Profile?.TEXT_START_DATE_OR_UNCHECKED_PRESENT,
    TEXT_ALREADY_ADDED = English?.Profile?.TEXT_ALREADY_ADDED,
    TEXT_WOULD_YOU_LIKE_TO = English?.Profile?.TEXT_WOULD_YOU_LIKE_TO,
    TEXT_ADD_NEW_ENTRY = English?.Profile?.TEXT_ADD_NEW_ENTRY,
    TEXT_UPDATE_TIMEFRAME = English?.Profile?.TEXT_UPDATE_TIMEFRAME,
    TEXT_UPDATE = English?.Profile?.TEXT_UPDATE,
    TEXT_ADD_NEW = English?.Profile?.TEXT_ADD_NEW,
    TEXT_COMPANY_EXIST_SELECTED_TIMEFRAME = English?.Profile?.TEXT_COMPANY_EXIST_SELECTED_TIMEFRAME,
    TEXT_START_DATE_BEFORE_END = English?.Profile?.TEXT_START_DATE_BEFORE_END,
    TEXT_CURRENTLY_WORK_HERE = English?.Profile?.TEXT_CURRENTLY_WORK_HERE,
    TEXT_REQUIRED = English?.Profile?.TEXT_REQUIRED,
    TEXT_MONTH_YEAR = English?.Profile?.TEXT_MONTH_YEAR
  } = multiLanguageData?.Profile || {};

  const debouncedCompanyname = UseDebounce(company?.title, 500);

  useEffect(() => {
    if (typeof company?.title === "string")
      if (debouncedCompanyname) getCompanylist(debouncedCompanyname);
  }, [debouncedCompanyname]);

  useEffect(() => {
    if (props.companyId !== 0 && props.showAddcompany === true) {
      getCompanydetail();
    }
    return () => {
      setCompanyinfo({
        id: 0,
        roleId: 0,
        startDate: null,
        endDate: null,
        present: false,
        jobDescription: ""
      });
      setCompany({ companyId: 0, title: "" });
      setDisablesave(true);
    };
  }, [props.showAddcompany]);

  const getCompanydetail = async () => {
    try {
      const getCompanyObj = {
        PageNr: 1,
        FullSearch: "",
        IncludeRecordNr: false,
        SearchList: [
          {
            UserId: loginData?.userInformation?.UserId,
            companyId: props.companyId
          }
        ]
      };
      const getResponse = await Postrequestcall(
        FETCH_USERS_COMPANIES,
        getCompanyObj,
        loginData?.accessToken
      );
      if (getResponse?.status === 201) {
        let getCompany = getResponse?.data?.data[0];
        setCompanyinfo({
          ...compnayInfo,
          id: getCompany?.id,
          startDate: getCompany?.startDate === null ? null : dayjs(getCompany?.startDate),
          endDate: getCompany?.endDate === null ? null : dayjs(getCompany?.endDate),
          present: getCompany?.currentCompany,
          jobDescription: getCompany?.description,
          prevJobdescription: getCompany?.description
        });
        setCompany({
          companyId: getCompany?.companyId,
          title: getCompany?.companyName
        });
      }
    } catch (error) {}
  };

  const onCompanychange = async (e) => {
    const { name, value, checked } = e.target;

    if (name === "present") {
      setCompanyinfo({
        ...compnayInfo,
        present: checked,
        endDate: checked ? null : compnayInfo.endDate
      });
      setDisablesave(company?.title === "" ? true : false);
    } else if (name === "title") {
      const cleanedTitle = value.replace(/^[^A-Za-z0-9]+/, "");
      setCompany({
        ...company,
        title: cleanedTitle
      });
      if (cleanedTitle === "") {
        setSelectcompany(false);
        setDisablesave(true);
      } else {
        setSelectcompany(true);
        setDisablesave(false);
      }
    } else if (name === "jobDescription") {
      const cleanedDescription = value.replace(/^[^A-Za-z0-9]+/, "");
      setCompanyinfo({
        ...compnayInfo,
        [name]: cleanedDescription
      });
      setDisablesave(company?.title === "" ? true : false);
    } else {
      setCompanyinfo({
        ...compnayInfo,
        [name]: value
      });
      setDisablesave(company?.title === "" ? true : false);
    }
  };

  const onClearcompany = () => {
    setCompany({
      ...company,
      companyId: 0,
      title: ""
    });
    setDisablesave(true);
  };

  const onCompanyselect = (event, newValue) => {
    setSelectcompany(false);
    if (newValue?.inputValue) {
      let getObj = {
        companyId: 0,
        title: newValue?.inputValue
      };
      setCompany(getObj);
    } else if (newValue === null) {
      setCompany({
        ...company,
        companyId: 0,
        title: ""
      });
    } else {
      setCompany(newValue);
    }
  };

  const onStartdatechange = (date) => {
    setCompanyinfo({
      ...compnayInfo,
      startDate: date
    });
    setDisablesave(company?.title === "" ? true : false);
  };

  const onEnddatechange = (date) => {
    setCompanyinfo({
      ...compnayInfo,
      endDate: date
    });
    setDisablesave(company?.title === "" ? true : false);
  };

  const getCompanylist = async () => {
    try {
      // OLD API: FETCH_COMPANIES (commented, do not delete)
      // let getObject = {
      //   IncludeRecordNr: true,
      //   NrOfRecPerPage: 0,
      //   SearchList: [{ name: company?.title, manufacturer: false }],
      //   SortList: [{ FieldName: "Name", Direction: "ASC" }]
      // };
      // const getList = await Postrequestcall(FETCH_COMPANIES, getObject, loginData?.accessToken);
      
      // NEW API: FETCH_COMPANIES_2 (active)
      let getObject = {
        UserId: loginData?.userInformation?.UserId ?? 0,
        SearchString: company?.title || "",
        PageNumber: 1,
        PageSize: 50,
        Manufacturer: false,
        Id: 0
      };
      const getList = await Postrequestcall(FETCH_COMPANIES_2, getObject, loginData?.accessToken);
      if (getList.status === 201) {
        let getUpdatedlist = Removeduplicates(getList?.data?.data, "name");
        getUpdatedlist = getUpdatedlist.map((item) => {
          return {
            title: item?.name,
            companyId: item?.id
          };
        });
        setCompanylist(getUpdatedlist);
      }
    } catch (error) {}
  };

  const handleOnsave = async () => {
    let startDate =
      compnayInfo?.startDate === null ? null : compnayInfo?.startDate.format("YYYY-MM-DD");
    let endDate = compnayInfo?.endDate === null ? null : compnayInfo?.endDate.format("YYYY-MM-DD");
    if (!compnayInfo?.present && startDate > endDate) {
      let alertObj = {
        showAlert: true,
        title: "",
        text: `${TEXT_START_DATE_BEFORE_END}, ${TEXT_CURRENTLY_WORK_HERE}`
      };
      dispatch(setShowalert(alertObj));
      return;
    }
    if (!compnayInfo?.present && startDate && endDate == null) {
      let alertObj = {
        showAlert: true,
        title: "",
        text: `${TEXT_START_DATE_BEFORE_END}, ${TEXT_CURRENTLY_WORK_HERE}`
      };
      dispatch(setShowalert(alertObj));
      return;
    }
    if (compnayInfo?.present && startDate == null) {
      let alertObj = {
        showAlert: true,
        title: "",
        text: TEXT_START_DATE_OR_UNCHECKED_PRESENT
      };
      dispatch(setShowalert(alertObj));
      return;
    }
    if (company?.companyId === 0 && company?.title !== "") {
      let getComponyId = await onSavecompany();
      formatTimeframe(getComponyId);
    } else {
      formatTimeframe(company?.companyId);
    }
  };

  const onSavecompany = async () => {
    try {
      setIsloading(true);
      // If we create new company we send id 0
      const getObject = {
        UserId: loginData?.userInformation?.UserId,
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: 0,
            Name: company?.title,
            ModifiedBy: loginData?.userInformation?.UserId,
            RecordStatusId: 1,
            Manufacturer: false
          }
        ]
      };
      const getResponse = await Postrequestcall(SAVE_COMPANIES, getObject, loginData?.accessToken);
      if (getResponse?.status === 201) {
        if (getResponse?.data?.data?.length > 0) {
          return getResponse?.data?.data[0]?.objData?.id;
        }
      }
    } catch (error) {
      setIsloading(false);
    } finally {
    }
  };

  const formatTimeframe = async (getComponyId) => {
    let isCompanyAdd = true;
    let isCompanyOutOfFrame = false;
    let isNewCompany = false;
    let startDate =
      compnayInfo?.startDate === null ? null : compnayInfo?.startDate.format("YYYY-MM-DD");
    let endDate = compnayInfo?.endDate === null ? null : compnayInfo?.endDate.format("YYYY-MM-DD");
    const comp = props.allCompanies
      .filter((comp) => comp.companyId === getComponyId)
      .sort((a, b) => {
        let dateA = new Date(a.startDate),
          dateB = new Date(b.startDate);
        return dateA - dateB;
      });

    if (comp?.length !== 0) {
      let companyStartDate = comp?.[0]?.startDate
        ? moment(comp[0]?.startDate).format("YYYY-MM-DD")
        : null;
      let companyEndDate = comp[0]?.endDate ? moment(comp[0]?.endDate).format("YYYY-MM-DD") : null;
      let newStartDate = compnayInfo?.startDate ? startDate : null;
      let newEndDate = compnayInfo?.endDate ? endDate : null;

      if (!companyStartDate && !companyEndDate && !newStartDate && !newEndDate) {
        // 1. no company update
        isCompanyAdd = false;
        if (props?.edit) {
          if (newEndDate === null && endDate === null) {
            isCompanyAdd = true;
          }
        }
      } else if (
        !companyStartDate &&
        !companyEndDate &&
        newStartDate &&
        (!newEndDate || newEndDate)
      ) {
        // 2. update company, show out of frame dialog, CSD1 = CSD2, CED1 = CED2
        isCompanyOutOfFrame = true;
        companyStartDate = newStartDate;
        companyEndDate = newEndDate;
      } else if (companyStartDate && companyEndDate && newEndDate < companyStartDate) {
        // 3. Add separate company
        isCompanyAdd = true;
        isCompanyOutOfFrame = true;
        if (moment(companyStartDate).diff(moment(newEndDate), "months") === 1) {
          companyStartDate = newStartDate;
        } else isNewCompany = true;
      } else if (companyStartDate && companyEndDate && newStartDate > companyEndDate) {
        // 4. Add separate company
        isCompanyAdd = true;
        isCompanyOutOfFrame = true;
        if (moment(newStartDate).diff(moment(companyEndDate), "months") === 1) {
          companyEndDate = newEndDate;
        } else isNewCompany = true;
      } else if (
        companyStartDate &&
        companyEndDate &&
        newStartDate >= companyStartDate &&
        newEndDate <= companyEndDate
      ) {
        // 5. no company update
        isCompanyAdd = false;
      } else if (
        companyStartDate &&
        companyEndDate &&
        newStartDate < companyStartDate &&
        newEndDate >= companyStartDate &&
        newEndDate <= companyEndDate
      ) {
        // 6. update company, show out of frame dialog, CSD1 = CSD2
        isCompanyOutOfFrame = true;
        companyStartDate = newStartDate;
      } else if (
        companyStartDate &&
        companyEndDate &&
        newStartDate < companyStartDate &&
        !newEndDate
      ) {
        // 7. update company, show out of frame dialog, CSD1 = CSD2
        isCompanyOutOfFrame = true;
        companyStartDate = newStartDate;
      } else if (
        companyStartDate &&
        companyEndDate &&
        newStartDate >= companyStartDate &&
        newStartDate <= companyEndDate &&
        newEndDate > companyEndDate
      ) {
        // 8. update company, show out of frame dialog, CED1 = CED2
        isCompanyOutOfFrame = true;
        companyEndDate = newEndDate;
      } else if (
        companyStartDate &&
        companyEndDate &&
        newStartDate >= companyStartDate &&
        newStartDate <= companyEndDate &&
        newEndDate == null
      ) {
        // 9. no company update
        isCompanyAdd = true;
      } else if (
        companyStartDate &&
        companyEndDate &&
        newStartDate < companyStartDate &&
        newEndDate > companyEndDate
      ) {
        // 10. update company, show out of frame dialog, CSD1 = CSD2, CED1 = CED2
        isCompanyOutOfFrame = true;
        companyStartDate = newStartDate;
        companyEndDate = newEndDate;
      } else if (
        companyStartDate &&
        !companyEndDate &&
        newStartDate < companyStartDate &&
        !newEndDate
      ) {
        // 11. update company, show out of frame dialog, CSD1 = CSD2
        isCompanyOutOfFrame = true;
        companyStartDate = newStartDate;
      } else if (
        companyStartDate &&
        !companyEndDate &&
        newStartDate < companyStartDate &&
        newEndDate
      ) {
        // 12. update company, show out of frame dialog, CSD1 = CSD2, CED1 = CED2
        isCompanyOutOfFrame = true;
        companyStartDate = newStartDate;
        companyEndDate = newEndDate;
      } else if (
        companyStartDate &&
        !companyEndDate &&
        newStartDate > companyStartDate &&
        !newEndDate
      ) {
        // 13. no company update
        isCompanyAdd = false;
      } else if (
        companyStartDate &&
        !companyEndDate &&
        newStartDate > companyStartDate &&
        newEndDate
      ) {
        // 14. update company, show out of frame dialog, update CED1 = CED2;
        isCompanyOutOfFrame = true;
        companyEndDate = newEndDate;
      }
      if (isCompanyOutOfFrame) {
        setTimeframeModalType("isCompanyOutOfFrame");
        setTimeframeModalBody(
          `${TEXT_ALREADY_ADDED} ${company?.title}. ${TEXT_WOULD_YOU_LIKE_TO} ${
            isNewCompany ? TEXT_ADD_NEW_ENTRY : TEXT_UPDATE_TIMEFRAME
          }?`
        );
        setUpdateModalButton(!isNewCompany ? TEXT_UPDATE : "");
        setAddDetailModalButton(TEXT_ADD_NEW);
        setCompanylist(comp[0]);
        setCompanyStartDateNew(companyStartDate);
        setCompanyEndDateNew(companyEndDate);
        setIsCompanyOutOfFrameFlag(isCompanyOutOfFrame);
        return;
      }
      if (props.companyId !== 0) {
        if (
          compnayInfo.jobDescription !== compnayInfo.prevJobdescription &&
          !(!companyStartDate && !companyEndDate && !newStartDate && !newEndDate)
        ) {
          isCompanyAdd = true;
        }
      }
      if (!isCompanyAdd) {
        setCompanylist(comp[0]);
        setCompanyStartDateNew(companyStartDate);
        setCompanyEndDateNew(companyEndDate);
        let alertObj = {
          showAlert: true,
          title: "",
          text: TEXT_COMPANY_EXIST_SELECTED_TIMEFRAME
        };
        dispatch(setShowalert(alertObj));
        return;
      }
      let obj = {
        data: comp[0],
        companyStartDateNew: companyStartDate,
        companyEndDateNew: companyEndDate == null ? newEndDate : companyEndDate,
        currentCompany: compnayInfo?.present,
        description: compnayInfo?.jobDescription
      };
      await handleUpdate(obj);
    } else {
      await handleSaveCompany(getComponyId);
    }
    setIsloading(false);
  };

  const handleUpdate = async (params) => {
    try {
      const companyObj = {
        UserId: loginData?.userInformation?.UserId,
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: isCompanyOutOfFrameFlag ? params?.data?.id : compnayInfo?.id,
            UserId: loginData?.userInformation?.UserId,
            RoleId: isCompanyOutOfFrameFlag ? params?.data?.roleId : compnayInfo?.roleId,
            CompanyId: params.data?.companyId,
            StartDate: params.companyStartDateNew
              ? moment(params.companyStartDateNew).format("YYYY-MM-DD")
              : null,
            endDate:
              params?.currentCompany === true
                ? null
                : params.companyEndDateNew
                  ? moment(params.companyEndDateNew).format("YYYY-MM-DD")
                  : null,
            ModifiedBy: loginData?.userInformation?.UserId,
            CurrentCompany: params?.currentCompany,
            IncludeInResume: params.data?.includeResume ? params.data?.includeResume : true,
            Description: params?.description
          }
        ]
      };
      await Postrequestcall(SAVE_USER_COMPANIES, companyObj, loginData?.accessToken);
      props.getExperience();
      props.handleClose();
    } catch (error) {
      console.log("handleUpdate-> Error WHile Saving User Companie: ", error);
    }
  };

  const handleSaveCompany = async (getComponyId) => {
    try {
      const companyObj = {
        userId: loginData?.userInformation?.UserId,
        saveList: [
          {
            id: 0,
            userId: loginData?.userInformation?.UserId,
            companyId: getComponyId,
            startDate: compnayInfo?.startDate ? compnayInfo?.startDate.format("YYYY-MM-DD") : null,
            endDate:
              compnayInfo?.present === true
                ? null
                : compnayInfo?.endDate
                  ? compnayInfo?.endDate.format("YYYY-MM-DD")
                  : null,
            currentCompany: compnayInfo?.present,
            includeInResume: true,
            description: compnayInfo?.jobDescription,
            CreatedBy: loginData?.userInformation?.UserId,
            modifiedBy: loginData?.userInformation?.UserId
          }
        ]
      };
      const getResponse = await Postrequestcall(
        SAVE_USER_COMPANIES,
        companyObj,
        loginData?.accessToken
      );
      if (getResponse.status === 201) {
        props.getExperience();
        props.handleClose();
      }
    } catch (error) {
      console.log("handleSaveCompany-> Error While Saving User Company: ", error);
    }
  };

  const handleDeleteButtonClick = async () => {
    try {
      const getObject = {
        UserId: loginData?.userInformation?.UserId,
        ReturnRecordId: false,
        ReturnRecordError: true,
        DeleteList: [
          {
            Id: compnayInfo?.id,
            ModifiedBy: loginData?.userInformation?.UserId
          }
        ]
      };
      const getResponse = await Postrequestcall(
        DELETE_USER_COMPANIES,
        getObject,
        loginData?.accessToken
      );
      if (getResponse?.status === 201) {
        setConfirmationModalOpen(false);
        props.getExperience();
        props.handleClose();
      }
    } catch (error) {
      console.log("handleDeleteButtonClick-> Error While Deleting User Company: ", error);
    }
  };

  const onDeletecompany = () => {
    setConfirmationModalOpen(true);
  };

  const handleTogglePicker = (e, picker) => {
    e.stopPropagation();
    e.preventDefault();
    if (picker === "end" && !compnayInfo.present) {
      setOpenenddate(openEnddate ? false : true);
    } else if (picker === "start") {
      setOpenstartdate(openStartdate ? false : true);
    }
  };

  const handleClear = (e, picker) => {
    e.preventDefault();
    e.stopPropagation();
    if (picker === "start") {
      setOpenstartdate(false);
      setCompanyinfo({ ...compnayInfo, startDate: null });
    }
    if (picker === "end") {
      setOpenenddate(false);
      setCompanyinfo({ ...compnayInfo, endDate: null });
    }
  };

  return (
    <>
      {discardModalOpen && (
        <PromptModal
          isOpen={discardModalOpen}
          onClose={() => setDiscardModalOpen(false)}
          title={MODAL_DISCARD_TITLE}
          desc={DISCARD_MODAL_DESCRIPTION}
          redButtonText={BUTTON_DISCARD}
          blueButtonTextFirst={BUTTON_GOBACK}
          onRedButtonClick={props.handleClose}
        />
      )}

      {confirmationModalOpen && (
        <PromptModal
          isOpen={confirmationModalOpen}
          onClose={() => setConfirmationModalOpen(false)}
          title={MODAL_DELETE_TITLE}
          desc={TEXT_DESC_CONFIRMATION}
          redButtonText={BUTTON_DELETE}
          blueButtonTextFirst={BUTTON_GOBACK}
          onRedButtonClick={handleDeleteButtonClick}
        />
      )}

      {timeframeModalType !== null && (
        <PromptModal
          isOpen={timeframeModalType !== null}
          onClose={() => {
            setTimeframeModalType(null);
            setTimeframeModalTitle(null);
            setTimeframeModalBody(null);
          }}
          title={timeframeModalTitle}
          desc={timeframeModalBody}
          redButtonText={BUTTON_CANCEL}
          onRedButtonClick={() => {
            setTimeframeModalType(null);
            setTimeframeModalTitle(null);
            setTimeframeModalBody(null);
          }}
          blueButtonText={updateModalButton}
          onBlueButtonClick={() => {
            let companyDataNew = props.allCompanies.filter(
              (comp) => comp.id === company?.companyId
            );
            let getObj = {
              data: isCompanyOutOfFrameFlag ? compnaylist : companyDataNew[0],
              companyStartDateNew: companyStartDateNew,
              companyEndDateNew: companyEndDateNew,
              currentCompany: compnayInfo?.present,
              description: compnayInfo?.jobDescription
            };
            handleUpdate(getObj);
            setTimeframeModalType(null);
            setTimeframeModalTitle(null);
            setTimeframeModalBody(null);
            props.handleClose();
          }}
          blueButtonText2={addDetailModalButton}
          onBlueButtonClick2={() => {
            handleSaveCompany(props.companyId);
            setTimeframeModalType(null);
            setTimeframeModalTitle(null);
            setTimeframeModalBody(null);
          }}
        />
      )}

      <Modal open={props.showAddcompany}>
        <Box className="user-modal-responsive">
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between"
            }}>
            <Typography className="add-title">
              {props.companyId !== 0 ? TEXT_EDIT_COMPANY_TO_PROFILE : TEXT_ADD_COMPANY_TO_PROFILE}
            </Typography>
            <Stack flexDirection={"row"} gap={1} alignItems={"center"}>
              <IconButton size="small" onClick={props.handleClose}>
                <CloseIcon />
              </IconButton>
              <IconButton
                size="small"
                disabled={disableSave || isLoading}
                onClick={() => handleOnsave()}>
                {isLoading ? (
                  <CircularProgress size={"large"} sx={{ width: "25px" }} />
                ) : (
                  <SaveIcon style={{ color: disableSave || isLoading ? BIGrey : BIBlue }} />
                )}
              </IconButton>
              {props.companyId !== 0 && (
                <IconButton onClick={onDeletecompany}>
                  <DeleteIcon color="error" />
                </IconButton>
              )}
            </Stack>
          </Box>
          <InputLabel>{TEXT_REQUIRED}</InputLabel>
          <Stack gap={2.5} marginTop={1}>
            <Autocomplete
              size="medium"
              inputValue={company?.title || ""}
              open={selectCompany}
              options={compnaylist} // Array of strings
              fullWidth
              getOptionLabel={(option) => {
                if (typeof option === "string") {
                  return option;
                }
                if (option?.title) {
                  return option?.title;
                }
                return option?.title;
              }}
              filterOptions={(options, params) => {
                const filtered = filter(options, params);
                const { inputValue } = params;
                const isExisting = options?.some((option) => inputValue === option?.title);
                if (inputValue !== "" && !isExisting) {
                  filtered.push({
                    inputValue,
                    companyId: 0,
                    title: `${BUTTON_ADD} "${inputValue}"`
                  });
                }
                return filtered;
              }}
              renderOption={(props, option) => <li {...props}>{option?.title}</li>}
              renderInput={(params) => (
                <TextField
                  {...params}
                  name="title"
                  onChange={onCompanychange}
                  label={`${TEXT_COMPANY} *`}
                  // placeholder="required*"
                />
              )}
              onChange={(event, newValue) => onCompanyselect(event, newValue)}
              clearOnBlur={true}
              freeSolo
              disabled={props.companyId !== 0 ? true : false}
              clearIcon={<CloseIcon onClick={onClearcompany} />}
            />
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                enableAccessibleFieldDOMStructure={false}
                autoFocus={false}
                yearsPerRow={3}
                maxDate={dayjs()}
                openTo="year"
                value={compnayInfo?.startDate ? dayjs(compnayInfo.startDate) : null}
                onChange={onStartdatechange}
                open={openStartdate}
                onOpen={() => setOpenstartdate(true)}
                onClose={() => setOpenstartdate(false)}
                views={["year", "month"]} // Show only Month & Year
                label={TEXT_START_DATE}
                name="startDate"
                className="timesheet-picker"
                format="MMM YYYY"
                slots={{ textField: TextField }}
                slotProps={{
                  textField: {
                    fullWidth: true,
                    size: "medium",
                    error: false,
                    placeholder: TEXT_MONTH_YEAR,
                    InputLabelProps: { shrink: true },
                    onClick: () => setOpenstartdate(true),
                    InputProps: {
                      startAdornment: (
                        <IconButton onClick={(e) => handleTogglePicker(e, "start")}>
                          <CalendarTodayIcon />
                        </IconButton>
                      ),
                      endAdornment:
                        compnayInfo.startDate != null ? (
                          <IconButton onClick={(e) => handleClear(e, "start")}>
                            <CloseIcon />
                          </IconButton>
                        ) : null
                    },
                    onFocus: (e) => {
                      e.stopPropagation();
                      e.preventDefault();
                    }
                  }
                }}
              />
            </LocalizationProvider>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                enableAccessibleFieldDOMStructure={false}
                maxDate={dayjs()}
                openTo="year"
                value={compnayInfo?.endDate ? dayjs(compnayInfo.endDate) : null}
                onChange={onEnddatechange}
                open={openEnddate}
                onClose={() => setOpenenddate(false)}
                onOpen={() => !compnayInfo?.present && setOpenenddate(true)} // Prevent opening when disabled
                label={compnayInfo?.present ? "" : TEXT_END_DATE}
                name="endDate"
                views={["year", "month"]} // Show only Month & Year
                className="timesheet-picker"
                format="MMM YYYY"
                slotProps={{
                  textField: {
                    fullWidth: true,
                    size: "medium",
                    error: false,
                    placeholder: TEXT_MONTH_YEAR,
                    InputLabelProps: { shrink: true },
                    onClick: (e) => {
                      if (compnayInfo?.present) {
                        e.stopPropagation(); // Prevents event from propagating
                      } else {
                        setOpenenddate(true);
                      }
                    },
                    InputProps: {
                      startAdornment: (
                        <IconButton onClick={(e) => handleTogglePicker(e, "end")}>
                          <CalendarTodayIcon />
                        </IconButton>
                      ),
                      endAdornment:
                        compnayInfo.endDate != null ? (
                          <IconButton onClick={(e) => handleClear(e, "end")}>
                            <CloseIcon />
                          </IconButton>
                        ) : null
                    },
                    onFocus: (e) => {
                      e.stopPropagation();
                      e.preventDefault();
                    }
                  }
                }}
                disabled={compnayInfo?.present}
              />
            </LocalizationProvider>
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  checked={compnayInfo?.present}
                  name="present"
                  onChange={onCompanychange}
                  size="medium"
                />
              }
              label={TEXT_PRESENT}
            />
            <div>
              <TextField
                onChange={onCompanychange}
                value={compnayInfo?.jobDescription}
                label={TEXT_JOB_DESCRIPTION}
                name="jobDescription"
                placeholder={TEXT_JOB_DESCRIPTION}
                variant="outlined"
                fullWidth
                slotProps={{
                  input: {
                    rows: 3,
                    multiline: true,
                    inputComponent: "textarea",
                    size: "medium"
                  }
                }}
              />
            </div>
          </Stack>
        </Box>
      </Modal>
    </>
  );
}
